<template>
  <v-row class="ma-0 tabStyle" :class="{ changeTab: active }">
    <!-- <v-col cols="6" class="text-center tabItem startDay">시작일</v-col> -->
    <!-- <v-col cols="6" class="text-center tabItem endDay">종료일</v-col> -->
    <v-col cols="12" class="text-center calendar-title">날짜선택</v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
//import { getReturnYmd, getExtParLeaAppDetMap } from '@/api/workStatus';

export default {
  data: () => ({
    returnYmd: '',
    type: '',
    useDay: '',
  }),
  props: {
    activeTab: {
      type: String,
    },
  },
  computed: {
    ...mapGetters([
      'GET_APPL_CD',
      'GET_APPL_SEQ',
      'GET_ORG_APPL_SEQ',
      'GET_APPL_TYPE',
    ]),

    active() {
      if (this.activeTab === 'S') {
        return false;
      } else if (this.activeTab === 'E') {
        return true;
      } else {
        return null;
      }
    },
  },

  methods: {
    ...mapMutations('ELA', ['SET_E_YMD']),
  },

  async mounted() {},
};
</script>

<style>
.tabStyle .tabItem {
  padding: 15px 0px;
  font-size: 1.125rem;
  background-color: #f9fafa;
}
.tabStyle .tabItem .title-line {
  font-weight: bold;
  color: #3cb149;
}
.tabStyle .startDay {
  font-weight: bold;
  color: #3cb149;
}
.tabStyle .endDay {
  font-weight: 400;
  color: #979b9f;
}
.tabStyle.changeTab .startDay {
  font-weight: 400;
  color: #979b9f;
}
.tabStyle.changeTab .endDay {
  font-weight: bold;
  color: #3cb149;
}
</style>
